export default "images/bg4.jpg";